import styles from "./index.module.scss";

export const MobileIndex2024 = () => {
  return (
    <div className={styles["page"]}>
      <div className={styles["top-bg"]}></div>

      <div className={styles["title-intro"]}></div>
      <div className={styles["text-intro"]}></div>

      <div className={styles["title-selection"]}></div>
      <div
        className={styles["algo"]}
        onClick={() => {
          window.location.pathname = "/ai2024";
        }}
      >
        <div className={styles.btn}></div>
      </div>
      <div
        className={styles["robot"]}
        onClick={() => {
          window.location.pathname = "/robot2024";
        }}
      >
        <div className={styles.btn}></div>
      </div>

      <div className={styles["title-review"]}></div>
      <div className={styles["_review"]}>
        <div className={styles.block}>
          <div
            className={styles.b1}
            onClick={() => {
              window.open(
                "https://tianchi.aliyun.com/specials/promotion/gaiic2021#J_4728064770",
                "_blank"
              );
            }}
          ></div>
          <div
            className={styles.b2}
            onClick={() => {
              window.open("https://gaiic.caai.cn/2022", "_blank");
            }}
          ></div>
          <div
            className={styles.b3}
            onClick={() => {
              window.open("https://gaiic.caai.cn/2023", "_blank");
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};
